(function() {
    'use strict';

    angular.module('caffeprint.constants', [])
        .constant('modalConfirmConst', {
            removeTitle: 'Potwierdzenie usunięcia',
            removeDescriptionPrefix: 'Czy na pewno chcesz usunąć',
            actionTitle: 'Potwierdzenie działania',
            actionDescriptionPrefix: 'Czy na pewno chcesz'
        })
        .constant('dateFormatConst', {
            defaultPythonDate: 'YYYY-MM-DD',
            defaultPythonDatetime: 'YYYY-MM-DD',
            backendDate: 'DD.MM.YYYY',
            backendDatetime: 'DD.MM.YYYY HH:mm:ss',
            momentDate: 'DD.MM.YYYY',
            momentDatetime: 'DD.MM.YYYY HH:mm:ss',
            momentTime: 'HH:mm:ss',
            momentYear: 'YYYY',
            momentMonth: 'MM',
            datePicker: 'dd.MM.yyyy',
            datePickerWithoutDay: 'MM.yyyy',
            datePickerMin: { year: 2001, month: 1, day: 1 },
            datePickerMax: { year: 2030, month: 12, day: 31 },
            datetimePicker: 'dd.MM.yyyy HH:mm:ss',
            datetimePickerDefaultTime: '01:00 am',
            datetimePickerMin: { year: 2001, month: 1, day: 1 },
            datetimePickerMax: { year: 2030, month: 12, day: 31 },
            timePicker: 'HH:mm',
            timePickerDefaultTime: '23:59'
        })
        .constant('datatablePageSizesConst', [{
            title: 20,
            value: 20
        }, {
            title: 50,
            value: 50
        }, {
            title: 100,
            value: 100
        }, {
            title: 200,
            value: 200
        }])
        .constant('datatableDefaultPageSizeValueConst', 20)
        .constant('datatableDefaultEmptyValueConst', '—')
        .constant('companyLocalizationConst', [{
            value: 'PL',
            title: 'Polska'
        }, {
            value: 'DE',
            title: 'Niemcy'
        }])
        .constant('defaultErrorMessages', {
            noFileError: 'Plik nie istnieje.',
            fileDownloadError: 'Wystąpił błąd podczas pobierania pliku.',
            defaultError: 'Wystąpił błąd'
        });
})();
